import React, { FC } from "react";
import NewLayout from "../../components/new-ui/Layout";
import HeaderImage from "../../components/CaseStudyComponents/HeaderImage";
import Aside from "../../components/CaseStudyComponents/Aside";
import About from "../../components/CaseStudyComponents/About";
import Challenge from "../../components/CaseStudyComponents/Challenge";
import Solution from "../../components/CaseStudyComponents/Solution";
import Impact from "../../components/CaseStudyComponents/Impact";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import Signup from "../../components/CaseStudyComponents/Signup";
import Quote from "../../components/CaseStudyComponents/Quote";
import AchievementCard from "../../components/CaseStudyComponents/AchievementCard";

const SattvicStore: FC = () => {
    const cardData = [
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/vcare/fb.png",
            title: (
                <span className=" inline-block case-study-card-new">
                    <span className="block">
                        <span style={{ fontWeight: 700 }}>15% </span>increase in
                    </span>{" "}
                    Facebook conversion rate
                </span>
            ),
            count: " ",
            by: " ",
            borderColor: "#ACDAF1",
            boxShadowColor: "#D4ECF8",
            fontColor: "#3B7D9E",
            gradient: "linear-gradient(105.67deg, rgba(215, 235, 245, 0.2) 0%, #D7EBF5 95.66%)",
            customHeight: true,
            customPadding: true,
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/vcare/generation.png",
            title: <span className="px-20 inline-block case-study-card-new">Increased lead generation</span>,
            count: " ",
            by: " ",
            borderColor: "#C9E6AD",
            boxShadowColor: "#ECF8E1",
            fontColor: "#72A649",
            gradient: "linear-gradient(285.78deg, #ECF8E1 3.17%, rgba(236, 248, 225, 0.2) 96.84%)",
            customHeight: true,
            customPadding: true,
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/vcare/quality.png",
            title: <span className="case-study-card-new px-20 inline-block">Quality customer service</span>,
            count: " ",
            by: " ",
            borderColor: "#DEBEF3",
            boxShadowColor: "#EFE1F8",
            fontColor: "#9461B5",
            gradient: "linear-gradient(285.94deg, #EFE1F8 1.79%, rgba(239, 225, 248, 0.2) 98.89%)",
            customHeight: true,
            customPadding: true,
        },
    ];
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    return (
        <NewLayout
            title="VCare - Case Study | Gallabox"
            description="VCare increases their lead generation, conversion rate, and the quality of support provided to customers with the help of Gallabox."
            canonical="https://gallabox.com/case-study/vcare"
        >
            <HeaderImage
                imagePath={"https://assets.gallabox.com/gb-home/case-study/vcare/vcare-head-img.png"}
                imageText={"VCare increases their lead generation, conversion rate, and the quality of support provided to customers with the help of Gallabox."}
            />
            <div className="max-w-md  sm:max-w-max mx-auto px-5 sm:px-10 lg:px-32 mt-20">
                <section className="flex flex-col items-center sm:flex-row gap-5 my-20 justify-between ">
                    {cardData.map((eachobj) => {
                        return (
                            <AchievementCard
                                key={""}
                                imagePath={eachobj.imgpath}
                                imageTitle={eachobj.title}
                                count={eachobj.count}
                                by={eachobj.by}
                                borderColor={eachobj.borderColor}
                                boxShadowColor={eachobj.boxShadowColor}
                                fontColor={eachobj.fontColor}
                                gradient={eachobj.gradient}
                            />
                        );
                    })}
                </section>
                <div className="flex max-w-6xl mx-auto flex-col sm:flex-row gap-8">
                    <div className="basis-1/5 mx-auto ">
                        <Aside
                            data={[
                                {
                                    title: "Company",
                                    content: "Prabas VCare Health Clinic Pvt Ltd",
                                },
                                {
                                    title: "Industry",
                                    content: "Healthcare",
                                },
                                {
                                    title: "Employees",
                                    content: "1200+",
                                },
                                {
                                    title: "Product used",
                                    content: ["WhatsApp chatbot", "Integration", "WhatsApp Broadcast", "Shared Team Inbox"],
                                },
                                // {
                                //     title: "Chats per Month",
                                //     content: "5k+",
                                // },
                                {
                                    title: "Website",
                                    link: "www.vcaretrichology.com",
                                    content: "vcaretrichology.com",
                                },
                            ]}
                        />
                    </div>
                    <main className="basis-4/5">
                        <About
                            aboutLogo={"https://assets.gallabox.com/gb-home/case-study/vcare/vcare-logo.png"}
                            aboutTitle={"VCare"}
                            aboutContent={`VCare, India’s leading Hair & Skin Clinic, offers a wide range of latest solutions for all hair and skin problems. We take care of everything ranging from diagnosis and treatment for all hair & skin related issues.
                            `}
                        />
                        <Challenge
                            challengeTitle={" Difficulty in customer service and irrelevant lead generation "}
                            challengeList={[
                                "Before adopting the solution provided by Gallabox, the way our team interacted with our customers was never seamless.",
                                "Most of the leads that we generated from multiple sources ended up being irrelevant for our business. i.e. , we received a lot of junk leads.",
                                "Our conversion rate from Facebook was not as expected.",
                            ]}
                        />
                        <Quote
                            quoteText={"“After using Gallabox, the conversion rate for Facebook has increased by nearly 15%.”"}
                            quoteBy={"- J. Vimalnath,"}
                            position={"Assistant Manager of Digital Marketing at VCare"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <Solution
                            solutionTitle={" Using Gallabox, we were able to increase our lead generation and conversion rates."}
                            solutionContent={""}
                            solutionData={[
                                "The automation service in Gallabox has helped us significantly. It helps us interact with customers at a faster pace which in turn helps in lead generation.",
                                "Apart from automation, the best feature of Gallabox is the Broadcasting feature. It helps us reach out to people who are yet to be converted as a customer.",
                                "In addition to that, Gallabox aids in generating a soft copy of the customer’s invoice through API.",
                            ]}
                        />
                        <Quote
                            quoteText={
                                "“Our favorite feature in Gallabox is its Automation service. It aids in interacting with our customers at a faster pace. This, in turn, increases our lead generation.”"
                            }
                            quoteBy={"- J. Vimalnath,"}
                            position={"Assistant Manager of Digital Marketing at VCare"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <Impact
                            impactContent={[
                                `<li class="content">
                                After adopting Gallabox, we could now interact with our customers quickly and efficiently.
                    </li>`,
                                `<li class="content">
                                We also find that our business is generating more relevant leads.
                </li>`,
                                `<li class="content">
                                Our conversation rate for Facebook has increased by nearly 15%
            </li>`,
                            ]}
                        />
                    </main>
                </div>
            </div>
            <Signup img="https://assets.gallabox.com/gb-home/case-study/Robot.png" content="Want similar results?" btn="Sign Up For A Free Trial" />
            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />
        </NewLayout>
    );
};

export default SattvicStore;
